<div id="signinmaindiv" class="loggedInContainer">
    <div class="signInDetailsDiv">
        <div class="signInCard shadow-[0_2px_1px_-1px_#0003,0_1px_1px_#00000024,0_1px_3px_#0000001f]">
            <div class="row signInRowCls">
                <div class="loginSummary col-6">
                    <div class="loginSummaryContainer">
                        <div class="loginSummaryHeader">
                            <span>
                                <img [src]="'assets/images/' + R.LOGO_HREF + 'logo.png'" class="taxillaLogo" alt="logo" />
                            </span>
                        </div>
                        <div class="loginfooterLogo" *ngIf="['emguat', 'emgprod', 'kpmguat', 'kpmgprod'].indexOf(R.PLATFORM) >= 0">
                            <span>
                                Powered by
                                <img class="logo loginPageFooterLogo" src="assets/images/encomply/footer-logo.png" alt="Taxilla" />
                            </span>
                        </div>
                    </div>
                </div>
                <div class="loginDetails col-6">
                    <span class="showLoggedInText">
                        Logged in Successfully.
                        <a [routerLink]="'/'">Click here</a>
                        to go to home page.
                    </span>
                </div>
            </div>
        </div>
    </div>
</div>
